import React from 'react';
import { openExternalUrl } from '../../../utils/externalLink';

export const buildVenueAddress = (source = {}) =>
  [
    source?.venue_prefecture || source?.prefecture_name || source?.prefecture,
    source?.venue_city || source?.city_name || source?.city,
    source?.venue_address || source?.address,
  ]
    .map((value) => String(value || '').trim())
    .filter(Boolean)
    .join(' ');

export const buildVenueMapUrl = ({ name = '', address = '', fallback = '' } = {}) => {
  const query = [name, address].filter(Boolean).join(' ').trim() || String(fallback || '').trim();
  return query
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
    : '';
};

export default function EventVenueDisplay({
  venueName = '',
  venueId = null,
  venueDetailBasePath = '',
  address = '',
  fallback = '会場未設定',
  className = '',
  linkClassName = 'side-link',
  mapButtonClassName = 'side-map-btn',
  target = undefined,
  showMapButton = true,
  mapUrl = '',
}) {
  const name = String(venueName || '').trim();
  const id = venueId === null || venueId === undefined || venueId === '' ? '' : String(venueId);
  const href = id && venueDetailBasePath ? `${venueDetailBasePath.replace(/\/$/, '')}/${id}` : '';
  const resolvedMapUrl = mapUrl || buildVenueMapUrl({ name, address });

  return (
    <span className={className || undefined}>
      {href ? (
        <a
          href={href}
          className={linkClassName || undefined}
          target={target}
          rel={target === '_blank' ? 'noopener noreferrer' : undefined}
          onClick={(event) => event.stopPropagation()}
        >
          {name || '会場'}
        </a>
      ) : (
        <span>{name || fallback}</span>
      )}
      {showMapButton && resolvedMapUrl ? (
        <button
          type="button"
          className={mapButtonClassName}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            openExternalUrl(resolvedMapUrl);
          }}
          aria-label="Googleマップで開く"
          title="Googleマップで開く"
        >
          <i className="fa-solid fa-location-dot" aria-hidden="true" />
        </button>
      ) : null}
    </span>
  );
}
